const indexItems = [
  { label: '恋情实锤', count: '326篇', icon: 'ri-heart-pulse-line' },
  { label: '网红翻车', count: '258篇', icon: 'ri-error-warning-line' },
  { label: '综艺内幕', count: '192篇', icon: 'ri-tv-2-line' },
  { label: '圈内秘闻', count: '175篇', icon: 'ri-lock-2-line' },
  { label: '豪门恩怨', count: '148篇', icon: 'ri-vip-crown-line' },
  { label: '商业纠纷', count: '136篇', icon: 'ri-briefcase-line' },
  { label: '税务风波', count: '112篇', icon: 'ri-file-list-3-line' },
  { label: '海外爆料', count: '95篇', icon: 'ri-global-line' },
  { label: '片场直击', count: '89篇', icon: 'ri-camera-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            按话题分类浏览51吃瓜黑料，快速找到你感兴趣的爆料内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href={`#${i < 4 ? 'cards' : 'ranking'}`}
              className="group flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                  {item.label}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.count}</p>
              </div>
              <div className="flex-shrink-0 text-foreground-300 group-hover:text-primary-400 transition-colors duration-200">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}